import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';
import StyleSheet from 'stilr';

import i18n from 'app/common/i18n';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from 'app/common/button';
import AutoCompleteDAWA from 'app/common/autocomplete-dawa';

import ListItem from './list-item';
import ActivityDialog from './dialog-activities';
import SurveyDialog from './survey-dialog';
import { duplicate as duplicateDwelling } from 'app/redux/modules/dwellings';
import { connect } from 'react-redux';

import { create } from '../redux/modules/feedback';
import ConfirmPayment from '../stripe/confirmPayment';

function parseSearch(search) {
  return Object.fromEntries(new URLSearchParams(search || ''));
}

function isAdmin(user) {
  try {
    return (user && user.get('role') === 'admin') || false;
  } catch (e) {
    if (__DEV__) {
      console.error(e);
    }
  }
  return false;
}

const styles = StyleSheet.create({
  label: {
    display: 'inline-block',
    marginRight: '6px',
    fontSize: '10px',
    background: 'rgb(224, 224, 224)',
    borderRadius: '8px',
    padding: '0 10px',
    lineHeight: '20px',
    verticalAlign: 'top',
    textTransform: 'capitalize'
  },
  blur: {
    color: 'transparent !important',
    textShadow: '0 0 5px rgba(0,0,0,0.4)'
  }
});

@connect(({ auth: { user } }) => ({ user }), { duplicateDwelling, create })
@i18n
class DwellingsList extends Component {
  static propTypes = {
    list: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      duplicate: null,
      audit: null,
      showSurvey: false,
      dwellingUUID: null
    };
  }

  handleDuplicate = (duplicate) => this.setState({ duplicate });

  handleDeactivation = (dwelling) => {
    if (dwelling.status !== 'DRAFT') {
      this.setState({ showSurvey: true, dwellingUUID: dwelling.uuid });
    }
  };

  handleSubmit = (feedback) => {
    this.props.create({ ...feedback, dwellingId: this.state.dwellingUUID });
    this.setState({ showSurvey: false });
  };

  confirmDuplicate = () => {
    const { uuid, location } = this.state.duplicate;

    this.props.duplicateDwelling(uuid, location).then((result) => {
      this.props.navigate(`/dwellings/${result.payload.uuid}`);
    });
  };

  handleAudit = (uuid) => this.setState({ audit: uuid });
  handleAuditClose = () => this.setState({ audit: null });

  render() {
    const { list, disabled, style = {}, user } = this.props;

    const cellClassName = [disabled && styles.blur].filter(Boolean).join(' ');
    const admin = isAdmin(user);

    return (
      <div style={{ overflowX: 'auto' }}>
        <ConfirmPayment
          query={
            typeof window !== 'undefined'
              ? parseSearch(window.location.search)
              : {}
          }
        />

        <Table style={{ ...style, tableLayout: 'auto', minWidth: 700 }}>
          <TableHead>
            <TableRow>
              <TableCell padding="checkbox" />
              <TableCell>{this.props.i18n('Address')}</TableCell>
              <TableCell>{this.props.i18n('Rent')}</TableCell>
              <TableCell>{this.props.i18n('Size')}</TableCell>
              <TableCell>{this.props.i18n('Status')}</TableCell>
              <TableCell>{this.props.i18n('Annoncering')}</TableCell>
            </TableRow>
          </TableHead>

          <TableBody style={{ tableLayout: 'auto' }}>
            {list.map((item, idx) => (
              <ListItem
                key={item.get('uuid') || idx}
                item={item}
                cellClassName={cellClassName}
                onDuplicate={this.handleDuplicate}
                onAuditOpen={this.handleAudit}
                admin={admin}
                user={user}
                onDeactivation={this.handleDeactivation}
              />
            ))}
          </TableBody>
        </Table>

        {this.state.duplicate ? (
          <Dialog open onClose={() => this.setState({ duplicate: null })}>
            <DialogTitle>{`${this.props.i18n('Duplicate')} ${
              this.state.duplicate.address
            }`}</DialogTitle>

            <DialogContent>
              <AutoCompleteDAWA
                label={this.props.i18n('Address')}
                onSelect={(choosen, location) =>
                  this.setState({
                    duplicate: { ...this.state.duplicate, location }
                  })
                }
                placeholder="fx Marielundvej 20, 2730 Herlev"
              />
            </DialogContent>

            <DialogActions>
              <Button
                flat
                primary
                label={this.props.i18n('Cancel')}
                onClick={() => this.setState({ duplicate: null })}
              />
              <Button
                flat
                primary
                label={this.props.i18n('Duplicate')}
                onClick={this.confirmDuplicate}
              />
            </DialogActions>
          </Dialog>
        ) : this.state.audit ? (
          <ActivityDialog
            open
            uuid={this.state.audit}
            onClose={this.handleAuditClose}
          />
        ) : this.state.showSurvey ? (
          <SurveyDialog
            open={this.state.showSurvey}
            onSubmit={this.handleSubmit}
          />
        ) : null}
      </div>
    );
  }
}

function DwellingsListWithNavigate(props) {
  const navigate = useNavigate();
  return <DwellingsList {...props} navigate={navigate} />;
}

export default DwellingsListWithNavigate;